module.exports = __webpack_public_path__ + "img/Stab_SM.23c2f8ef.svg";